import { IAppState } from 'shared/common/state';
import { getOfferType } from 'shared/selectors/getOfferType';
import { isSuburban } from 'shared/utils/category';

export const selectIsSuburbanListing = (state: IAppState) => {
  return isSuburban(getOfferType(state));
};
